import { tt } from "../i18n/tt";
import { lazyI18n } from "../i18n/lazyText";
// 이용 가이드(docs.laeebly.io) 링크 — 화면 ↔ 문서 매핑 한 곳
//
// 진입점 세 곳이 모두 이 파일을 참조한다:
//   ① 계정 메뉴 「이용 가이드」  ② 우측 상단 도움말 아이콘  ③ 화면 제목 옆 도움말
// 문서가 늘거나 slug 가 바뀌면 여기만 고치면 된다.
//
// ⚠️ 가이드는 회원 전용이라 로그아웃 상태에서는 도움말 로그인 화면이 뜬다 — 정상 동작.

export const GUIDE_BASE = "https://docs.laeebly.io";

/** 가이드 첫 화면 (역할에 맞는 첫 문서로 자동 이동) */
export const GUIDE_HOME = GUIDE_BASE;

/**
 * 라우트 → 그 화면에 맞는 문서.
 * 여기 없는 화면은 도움말을 아예 표시하지 않는다 — 엉뚱한 문서로 보내지 않기 위해서.
 * label 은 버튼에 그대로 쓰인다.
 */
const SCREEN_GUIDES = lazyI18n(() => ({
  "/channel": { slug: "c-channel", label: tt("a.d6cf3fa9", "채널 등록 가이드") },
  "/video-inspection": { slug: "c-inspect", label: tt("a.e816453f", "검수 가이드") },
  "/revenue": { slug: "c-revenue", label: tt("a.8d613ba5", "수익 가이드") },
  "/total": { slug: "c-settle", label: tt("a.a3362e7c", "정산 가이드") },
}));

// 홈(`/home`)은 화면 제목 줄이 없어 링크를 끼울 자리가 없다 —
// 우측 상단 도움말 아이콘과 「처음 오셨나요?」 카드가 대신한다.
// 작품 상세·업로드(c-upload) 연결은 모달 안이라 후속으로 미뤘다.

/** slug → 전체 주소 */
export function guideUrl(slug) {
  if (!slug) return GUIDE_HOME;
  return `${GUIDE_BASE}/${slug}`;
}

/**
 * 라우트에 맞는 도움말 정보. 없으면 null (버튼 미표시).
 * `/channel/123` 처럼 하위 경로가 붙어도 상위 라우트로 매칭한다.
 */
export function guideForPath(pathname) {
  if (!pathname) return null;
  const exact = SCREEN_GUIDES[pathname];
  if (exact) return { ...exact, url: guideUrl(exact.slug) };

  // 가장 긴 접두사부터 확인 (`/video-inspection/manage` → `/video-inspection`)
  const match = Object.keys(SCREEN_GUIDES)
    .filter((route) => pathname.startsWith(`${route}/`))
    .sort((a, b) => b.length - a.length)[0];
  if (!match) return null;
  const found = SCREEN_GUIDES[match];
  return { ...found, url: guideUrl(found.slug) };
}

/** 테스트·문서용 — 등록된 라우트 목록 */
export function guideRoutes() {
  return Object.keys(SCREEN_GUIDES);
}
